export default "__VITE_ASSET__BbKuwqiW__"